export default __webpack_public_path__ + "static/Flare-b55ea189dd8455c0949c1455e4cf4db5.mp4";